import { Route } from "react-router";
import MainAdminPage from './MainAdminPage'

export default (<Route component={MainAdminPage} />)